import * as React from "react";

import { TextAnswer, TextQuestion, TextWrapper } from "./texts";
import { Ads } from "../shared/ads";

export const Faq = ({
    faqs,
    adIndex=1
}: {
    faqs: { question?: string; answer: string }[];
    adIndex?: number;
}) => {
    return (
        <TextWrapper>
            {faqs.map((faq, index) => {
                return (
                    <React.Fragment key={index}>
                    {faqs.length > 5 && index === 4 && <Ads idx={adIndex} />}
                    {faqs.length > 11 && index === 8 && <Ads idx={adIndex+1} />}
                        <div key={index}>
                            {faq.question && (
                                <TextQuestion
                                    text={faq.question}
                                ></TextQuestion>
                            )}
                            <TextAnswer
                                text={faq.answer}
                                index={index}
                            ></TextAnswer>
                        </div>
                    </React.Fragment>
                );
            })}
        </TextWrapper>
    );
};
